export interface TutorialsData {
  tutorialType: TutorialType;
  presented: boolean;
}

export enum TutorialType {
  LandingPage = 'landingPage',
  KanbanBoard = 'kanbanBoard',
  KanbanInstallationList = 'kanbanInstallationList',
}

export const initialTutorialsData: TutorialsData[] = [
  {
    tutorialType: TutorialType.LandingPage,
    presented: false,
  },
  {
    tutorialType: TutorialType.KanbanBoard,
    presented: false,
  },
  {
    tutorialType: TutorialType.KanbanInstallationList,
    presented: false,
  },
];
